import { Injectable } from '@angular/core';
import { Pedido } from '../models/pedido';
import { Subject } from "rxjs";
import { KanbanPedido } from '../kanbam/KanbamPedido';

@Injectable({
  providedIn: 'root'
})
export class EventService {

  public onGetListaPedidos = new Subject<Pedido[]>();

  public aposMoverItemKanban$ = new Subject<KanbanPedido>();

  constructor() {
    console.log("criado aqui")
  }


}
